

export const handleChangeErrors = (name, value, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados) => {

    let nuevoEstadoCampoReque = { ...estadoCampoReque };
  
  
    console.log("name", name);
    console.log("value", value);
  
    if (value == '') {
      nuevoEstadoCampoReque[name] = true;
    } else {
      nuevoEstadoCampoReque[name] = false;
    }
  
  
    setEstadoCampoReque(nuevoEstadoCampoReque);
    setEstadosActualizados(false);
  
  
  };
  
  
  
  export const handleSubmitErrorsPersonas = (
    formData,
    estadoCampoReque,
    setEstadoCampoReque,
    camposRequeridos,
    setEstadosActualizados
  ) => {
    let nuevoEstadoCampoReque = { ...estadoCampoReque };
  
    Object.keys(estadoCampoReque).forEach(campo => {
      const valor = formData[campo];
      //console.log(`Verificando campo: ${campo}, valor:`, valor);
  
      let estaVacio = false;
  
      if (Array.isArray(valor)) {
        estaVacio = valor.length === 0;
      } else if (typeof valor === 'object' && valor !== null) {
        estaVacio = Object.keys(valor).length === 0;
      } else {
        estaVacio = !valor && valor !== 0;
      }
      
    if (campo === "mail_empresa") {
      const validadorMailEmpresa = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
      if (valor && !validadorMailEmpresa.test(valor)) {
        estaVacio = true; // Marca como error si el email no es válido
      }
    }
  
      nuevoEstadoCampoReque[campo] = estaVacio;
      //console.log(`Campo ${campo} está vacío:`, estaVacio);
    });

  
    if (formData["imagenPersona_img"]) {
      nuevoEstadoCampoReque["imagenPersona_img"] = false;
    }
  
    setEstadoCampoReque(nuevoEstadoCampoReque);
    //console.log("Nuevo estado de los campos requeridos:", nuevoEstadoCampoReque);
  
    setEstadosActualizados(true);
  }
  
  
  
  
  export const todosDatosCorrectos = (formData, estadoCampoReque) => {
  
  
    console.log("estadoCampoReque", estadoCampoReque);
    const formDataVacio = Object.values(formData).every(value => value === '');
    
  
    let todosCamposFalse = () => {
      const todosRequeFalse = Object.values(estadoCampoReque).every(valor => valor === false && !formDataVacio);
  
      return todosRequeFalse;
    };
  
  
  
    return {
      todosCamposFalse
    };
  }